/**
 * lot X3 — bandeau « Mise à jour en cours » sur panne réseau.
 *
 * La logique de détection et de réessai vit dans `utils/reseauResilience.js` (partagée par
 * toutes les instances axios). Ici, uniquement l'affichage.
 */
import React, { useEffect, useState } from 'react';
import { EVENEMENT_RESEAU } from '../utils/reseauResilience';

const NetworkBanner = () => {
  // État initial relu du drapeau global : une panne survenue avant le montage doit être vue.
  const [indisponible, setIndisponible] = useState(() => Boolean(window.__komercesReseauKO));

  useEffect(() => {
    const surEvenement = (e) => setIndisponible(Boolean(e.detail?.indisponible));
    window.addEventListener(EVENEMENT_RESEAU, surEvenement);
    return () => window.removeEventListener(EVENEMENT_RESEAU, surEvenement);
  }, []);

  // Le bandeau est en position fixe : on décale le contenu pour ne pas masquer la barre du haut.
  useEffect(() => {
    document.body.style.paddingTop = indisponible ? '36px' : '';
    return () => { document.body.style.paddingTop = ''; };
  }, [indisponible]);

  if (!indisponible) return null;

  return (
    <div
      data-testid="network-banner"
      className="fixed top-0 left-0 right-0 z-[100] h-9 bg-amber-500 text-white text-sm font-medium px-4 flex items-center justify-center gap-2 shadow-md"
    >
      <i className="bi bi-arrow-repeat animate-spin"></i>
      Mise à jour en cours, reconnexion automatique…
    </div>
  );
};

export default NetworkBanner;
